module.exports = __webpack_public_path__ + "img/redpack.345ca0dc.png";